import { useEffect, useState } from "react";
import jwtDecode, { JwtPayload } from "jwt-decode";
import { getMidwayJwtToken } from "../auth/MidwayJwtToken";

let cachedAlias: string | null = null;

/**
 * Current Midway alias (JWT `sub`). The backend derives the actor from the same token, so this is
 * only used for presentation (owner vs contributor affordances) – never sent to the API.
 */
export default function useCurrentUser(): string | null {
  const [alias, setAlias] = useState<string | null>(cachedAlias);

  useEffect(() => {
    if (cachedAlias) return undefined;
    let cancelled = false;
    getMidwayJwtToken()
      .then((token) => {
        const decoded: JwtPayload = jwtDecode(token);
        cachedAlias = decoded.sub || null;
        if (!cancelled) setAlias(cachedAlias);
      })
      .catch((err) => console.error("Could not resolve current user", err));
    return () => {
      cancelled = true;
    };
  }, []);

  return alias;
}
